import { ApplyButton, SectionHeader } from "./shared";
import eligibilityImage from "../../assets/home/eligibility.jpg";

export default function HomeEligibility() {
  return (
    <section className="bg-white px-4 sm:px-6 lg:px-[80px] py-[60px]">
      <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row lg:items-center gap-10 lg:gap-16">
        <div className="flex-1 min-w-0 h-[240px] sm:h-[420px] bg-[#f8fafc] border border-[#e5e7eb] rounded-[24px] overflow-hidden">
          <img src={eligibilityImage} alt="Eligibility checklist" loading="lazy" className="size-full object-cover" />
        </div>
        <div className="w-full lg:w-[560px] shrink-0 flex flex-col gap-8">
          <SectionHeader align="left" badge="Eligibility" title="Eligibility Criteria" />
          <div className="flex flex-col gap-5 text-[#6a7282] text-[16px] leading-[26px]">
            <p>
              This product is intended for salaried individuals, with an indicative CIBIL score requirement of 650+. Age, income and document requirements: [To be confirmed].
            </p>
            <p>
              Final approval is subject to applicable eligibility and assessment criteria. Review the applicable terms before accepting a loan.
            </p>
          </div>
          <ApplyButton label="Check My Eligibility" location="home_eligibility" className="self-start px-6 py-3" />
        </div>
      </div>
    </section>
  );
}
